export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solicitud de soporte técnico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["de"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar mensaje"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archivos"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puedes cargar uno o varios archivos. Tamaño máximo de archivo - 10MB."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Texto del mensaje"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
}